export default __webpack_public_path__ + "tmp_src/components/Cart/CartItems~aurora.css.liquid";